const m = require('mithril');
const prop = require('mithril/stream');
const dragscroll = require('../libs/dragscroll');
const equipmentClassToDisplayName = require('../libs/equipmentClassToDisplayName');
const loaders = require('../layout/components/loaders');
const edit = require('../layout/components/edit');
const modal = require('../layout/components/modal');
const auth = require('../auth/models/session');
const modelActions = require('../network//components/modelActions');
const modelDetail = require('../components/modelDetail');
const paginationWithSearch = require('../data/components/paginationWithSearch');
const rowActionDropdown = require('../components/rowActionDropdown');
const bacnetEnums = require('../../../../lib/bacnetEnums');
const tableColumns = require('../network/components/tableColumns');
const pageTitle = require('../layout/pageTitle');
const pageRequestState = require('../layout/components/pageRequestState');

const STATUSES = ['ok', 'unknown', 'warning', 'error'];
const fieldsToShow = ['name', 'index', 'unit', 'scale', 'writable', 'error', 'overrideActive', 'alarmStatus', 'alarmEnabled', 'alarmName'];
const page = {};

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

function propertyRowActions(ctrl, children) {
  return [
    {
      label: 'Edit ' + ctrl.form.name,
      icon: 'ion-ios-compose',
      onclick: function () { ctrl.form.editDialogue(children); }
    },
    {
      label: 'Delete ' + ctrl.form.name,
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { ctrl.form.deleteDialogue(children); }
    }
  ];
}

function renderPropertyNameCell(ctrl, children, url) {
  return m('div.flex.items-center.justify-between', [
    m(m.route.Link, { href: url }, children.name),
    m('div.ml3.flex-none', [
      actionDropdown(propertyRowActions(ctrl, children))
    ])
  ]);
}

page.oninit = function (vnode) {
  var ctrl = this;
  ctrl.recordModel = vnode.attrs.recordModel;
  ctrl.form = vnode.attrs.form;
  ctrl.newNode = prop(false);
  pageRequestState.initialize(ctrl);
  pageTitle.set(null, { fallback: ctrl.recordModel.name });

  ctrl.init = function () {
    return pageRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        url: "/api/v1/" + ctrl.recordModel.url + '/' + m.route.param('id'),
        method: "GET"
      })
      .then(function (res) {
        ctrl.record = res;
        pageTitle.set(ctrl.record, { fallback: ctrl.recordModel.name });
        // Compute object type flags before any display transformation
        var rawType = Number(ctrl.record && ctrl.record.objectType);
        var OT = bacnetEnums && bacnetEnums.ObjectType || {};
        var isBinary = rawType === OT.BINARY_INPUT || rawType === OT.BINARY_OUTPUT || rawType === OT.BINARY_VALUE || rawType === OT.BINARY_LIGHTING_OUTPUT;
        // Show objectType as enumerated name for display
        var typeName = Object.keys(OT).find(function (k) { return OT[k] === rawType; }) || ctrl.record.objectType;
        ctrl.record.objectType = typeName;

        // Build a filtered detail model so we can hide binary-only labels on non-binary objects
        ctrl.detailModel = Object.assign({}, ctrl.recordModel);
        ctrl.detailModel.fields = Object.assign({}, ctrl.recordModel.fields);
        if (!isBinary) {
          if (ctrl.detailModel.fields.activeText) {
            ctrl.detailModel.fields.activeText = Object.assign({}, ctrl.detailModel.fields.activeText, { hidden: true });
          }
          if (ctrl.detailModel.fields.inactiveText) {
            ctrl.detailModel.fields.inactiveText = Object.assign({}, ctrl.detailModel.fields.inactiveText, { hidden: true });
          }
        }
        ctrl.sort();
        ctrl.newNode(true);
        // Poll groups are optional context. A failure must not hide the object.
        var deviceAncestor = (ctrl.record.breadcrumbs || []).find(function (b) {
          return (b['@id'] || '').toLowerCase().indexOf('/bacnetdevice/') !== -1 || b['@class'] === 'BacnetDevice';
        });
        if (!deviceAncestor || !deviceAncestor['@rid']) {
          ctrl.groups = [];
          return;
        }
        ctrl.deviceRid = deviceAncestor['@rid'];
        return loaders.requestWithLoader({
          url: '/api/v1/bacnetdevice/' + deviceAncestor['@rid'].slice(1) + '/pollgroups/',
          method: 'GET'
        }).then(function (groups) {
          ctrl.groups = groups || [];
        }).catch(function (error) {
          console.error('Unable to load BACnet poll groups:', error);
          ctrl.groups = [];
        });
      });
    }, { errorMessage: 'Unable to load BACnet object data:' });
  };

  ctrl.sort = function () {
    ctrl.record.children.sort(sortByStatus);
  };

  modal.on('closed', ctrl.init);
  
  ctrl.init();
  ctrl.childrenToShow = [];
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function () {
  var ctrl = this;
  var stateView = pageRequestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.record) return
  return m('div', [
    m("div.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.flex.justify-between.items-center.display",  [
      m('div.pb2.f-subheadline.fw5', [
        m('div.dib-ns.mr2', [
          m(m.route.Link, {href: '/networks'}, 'Networks'),
          ' / '
        ]),
        ctrl.record.breadcrumbs.map(function (ancestor, idx) {
          if (ancestor['@id'] == ctrl.record['@id']) {
            return m('div.dib-ns.mr2', ctrl.record.name)
          } else {
            return m('div.dib-ns.mr2', [
              m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
              ' / '
            ])
          }
        })
      ]),
      (function () {
        if(edit.vm.editing() && auth.user().isSuperuser == 1){
          return m(rowActionDropdown, {
            items: [
              {
                label: 'Edit ' + ctrl.recordModel.name,
                icon: 'ion-ios-compose',
                onclick: () => ctrl.recordModel.editDialogue(ctrl.record)
              },
              {
                label: 'New ' + ctrl.form.name,
                icon: 'ion-plus',
                onclick: () => ctrl.form.editDialogue({parent: ctrl.record['@rid']})
              }
            ]
          })
        }
      })(),
    ]),
    modelDetail(ctrl, ctrl.detailModel || ctrl.recordModel),
    modelActions(ctrl, ctrl.recordModel),
    (() => {
        console.log('ctrl.record.children', ctrl.record);
        if (ctrl.record.children.find(child => child.name == 'PRIORITY_ARRAY')) {
          let childPoints = ctrl.record.children;
          console.log('childPoints', childPoints);
        } else {
          return m('div', {style: {display: 'none'}}, )
        }
    })(),
    m('div.mh3.mv3.bw1.pv1.tc.f3.bb', equipmentClassToDisplayName(ctrl.form.name, true)),
    m('div.cf', browse(ctrl)),
  ])
};

function browse (ctrl) {
  var fieldsArray = [];
  for (const [key, propertyDef] of Object.entries(ctrl.form.fields)) {
    if (propertyDef.type) {
      fieldsArray.push(key);
    }
  }

  return m('div.mh3',[
    m(paginationWithSearch, {
      data: ctrl.record.children,
      newNode: ctrl.newNode,
      dataToShow: ctrl.childrenToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: ['name']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              tableColumns.colgroup(fieldsArray.concat(['description', 'pollGroup'])),
              m('thead', [
                m('tr', [ 
                  fieldsArray.map(field => {
                    return m('th.ph0.tl', field)
                  }),
		                  m('th.ph0.tl', 'Description'),
		                  m('th.ph0.tl', 'Poll Group')
	                ])
                
              ]),
              m('tbody', [
                ctrl.childrenToShow.map(children => {
                  if(!children['@rid']){
                    return m('tr', [
                      fieldsArray.map(field => {
                        return m('td.tl.nowrap',[
                          m('label',{style:{'visibility':'hidden'}}, 'No Data')  
                        ])
	                      }),
	                      m('td.tl.nowrap'),
	                      m('td.tl.nowrap')
	                    ])
	                  }else{
	                    let url = '/' + children['@id'].split('/').slice(3,5).join('/').toLowerCase();
	                    return m('tr', [
	                      fieldsArray.map(field => {
	                        return m('td.tl.nowrap', field == 'name' ? renderPropertyNameCell(ctrl, children, url) : children[field])
	                      }),
                      m('td.tl.nowrap', children.description || ''),
	                      m('td.tl.nowrap', [
	                        (ctrl.groups && ctrl.groups.length) ? m('select.form-control', {
                          value: children.pollGroup || '',
                          onchange: function (ev) {
                            var val = ev.target.value || null;
                            var body = { pollGroup: val };
                            loaders.requestWithLoader({
                              url: '/api/v1/bacnetproperty/' + children['@rid'].slice(1) + '/',
                              method: 'PUT',
                              body: body,
                              loader: 'submit'
                            }).then(function () {
                              children.pollGroup = val;
                              m.redraw();
                            }).catch(function (e) { alert(e); });
                          }
                        }, [
                          m('option', { value: '' }, '— None —'),
                          ctrl.groups.map(function (g) {
                            return m('option', { value: g['@rid'] }, g.name);
                          })
	                        ]) : m('span', '—')
	                      ])
	                    ])
                  }
                })
              ])
            ])
          ])
        ])
      ])
      
    ])
  ])
};

function sortByStatus (a,b) {
  if (STATUSES.indexOf(a.status) < STATUSES.indexOf(b.status)) {
    return 1;
  } else if (STATUSES.indexOf(a.status) > STATUSES.indexOf(b.status)) {
    return -1;
  } else {
    return 0;
  }
};



module.exports = page;
